import React from 'react';

import AnywhereListingsTable from './anywhere_listings/table';
import BuildoutListingsTable from './buildout_listings/table';
import { reorderableList } from 'helpers/react_dnd/reorderable_list';
import CollapsibleSection from './collapsible_section';
import Filters from './filters';

function UnmatchedListingsTables({ count } : { count: number }) {
  return (
    <CollapsibleSection count={count} title="Unmatched Listings">
      <Filters />
      <div className="d-flex gap-4">
        <div className="w-50">
          <AnywhereListingsTable />
        </div>
        <div className="w-50">
          <BuildoutListingsTable />
        </div>
      </div>
    </CollapsibleSection>
  );
}

export default reorderableList(UnmatchedListingsTables);
